export default "/Collision2Only.glb";